import { render } from "./Main.vue?vue&type=template&id=0fa65658&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=0fa65658&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0fa65658"

export default script